module.exports = __webpack_public_path__ + "static/media/UW-logo@2x.f9bf6756.png";